/**
 * Labstep
 */

import { Filter } from 'labstep-web/constants/filters';

export const filters: Filter[] = [
  Filter.created_by,
  Filter.assigned_to,
  Filter.date_range,
  Filter.tag,
  Filter.available_resource_item_count,
  Filter.molecule,
];
